import styled from 'styled-components';

const Wrap = styled.div`
  background-color: #3e454d;
  color: #c3c3c3;
  border-radius: 6px;
  width: 353px;
  z-index: 1000;
  //position: relative;

  position: fixed;
  //left: 50%;
  //top: 100px;

  //
  //&:after {
  //  content: '';
  //  border: solid 8px;
  //  border-color: transparent #3e454d transparent transparent;
  //  position: absolute;
  //  left: -16px;
  //  top: 12px;
  //}
`;

const StyledStarInfo = styled.div`
  min-height: 92px;
  box-sizing: border-box;
  display: flex;
  padding: 12px;
  align-items: center;
  justify-content: space-between;

  .avatar {
    width: 48px;
    height: 48px;
    margin-right: 14px;
    cursor: pointer;
    img {
      width: 48px;
      height: 48px;
      border-radius: 100%;
    }
  }

  .info {
    flex: auto;
  }

  .nickname {
    cursor: pointer;
    max-width: 8em;
    color: #40a3ff;
    font-size: var(--fs-md);
    margin-right: 4px;
  }
  .user-num {
    margin-top: 4px;
  }
  .row {
    display: flex;
    align-items: center;
  }
`;

const StyledMenu = styled.ul`
  white-space: nowrap;
  .mc-font {
    font-size: var(--fs-base);
  }
  li {
    position: relative;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    height: 40px;
    align-items: center;
    padding: 0 12px;
    &:hover {
      background-color: #4b5158;
      color: #fff;
      ul {
        display: block;
      }
    }
  }
  li:last-child:hover {
    border-radius: 0 0 6px 6px;
  }

  ul {
    position: absolute;
    display: none;
    width: 122px;
    left: 100%;
    top: 0;
    background: #4b5158;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    overflow: hidden;

    li {
      color: #c3c3c3;
      &:hover {
        color: #fff;
        background-color: #585d63;
      }
    }
  }

  &._subMenuLeft ul {
    right: 100%;
    left: auto;
  }
`;

export default {
  Wrap,
  StyledStarInfo,
  StyledMenu,
};
